module.exports = __webpack_public_path__ + "img/newsImg12-14.97251652.png";